import axiosInstance from "./axios-instance";
import { isMutationSuccess } from "./cache-utils";
import { invalidateOrderDataCache, resolveClientId, resolveOrderId } from "./cache-invalidation";

const getScopedAccountId = (accountId?: number): number => {
    if (typeof window === "undefined") {
        return Number(accountId || 0);
    }
    const ownerAccountId = Number(localStorage.getItem("ownerAccountId") || "0");
    if (ownerAccountId > 0) {
        return ownerAccountId;
    }
    if (Number(accountId) > 0) {
        return Number(accountId);
    }
    return Number(localStorage.getItem("accountId") || "0");
};

const withScopedAccountId = (payload: any) => {
    if (!payload || typeof payload !== "object") {
        return payload;
    }

    const scopedAccountId = getScopedAccountId(payload.accountId);
    if (!(scopedAccountId > 0)) {
        return payload;
    }

    return {
        ...payload,
        accountId: scopedAccountId,
    };
};

const searchDraperyOrderDesignEmbellishments = async (
    draperyOrderDesignId: number
) => {
    try {
        const response = await axiosInstance.get(
            `/draperyOrderDesignEmbellishment/search?draperyOrderDesignId=${draperyOrderDesignId}`
        );

        return response.data;
    } catch (error) {
        console.error(
            "Error with drapery Order Design Embellishment search:",
            error
        );
        throw error;
    }
};

const addDraperyOrderDesingEmbellishment = async (payload: any) => {
    try {
        const response = await axiosInstance.post(
            `/draperyOrderDesignEmbellishment/add`,
            withScopedAccountId(payload)
        );
        if (isMutationSuccess(response.data)) {
            invalidateOrderDataCache(resolveOrderId(payload, response.data), resolveClientId(payload, response.data));
        }

        return response.data;
    } catch (error) {
        console.error(
            "Error with drapery Order Design Embellishment add:",
            error
        );
        throw error;
    }
};

const editDraperyOrderDesignEmbellishment = async (payload: any) => {
    try {
        const response = await axiosInstance.put(
            `/draperyOrderDesignEmbellishment/edit`,
            withScopedAccountId(payload)
        );
        if (isMutationSuccess(response.data)) {
            invalidateOrderDataCache(resolveOrderId(payload, response.data), resolveClientId(payload, response.data));
        }

        return response.data;
    } catch (error) {
        console.error(
            "Error with drapery Order Design Embellishment edit:",
            error
        );
        throw error;
    }
};

const deleteDraperyOrderDesignEmbellishment = async (id: number) => {
    try {
        const response = await axiosInstance.delete(
            `/draperyOrderDesignEmbellishment/delete?id=${id}`
        );
        if (isMutationSuccess(response.data)) {
            invalidateOrderDataCache();
        }

        return response.data;
    } catch (error) {
        console.error(
            "Error with drapery Order Design Embellishment delete:",
            error
        );
        throw error;
    }
};

export {
    searchDraperyOrderDesignEmbellishments,
    addDraperyOrderDesingEmbellishment,
    editDraperyOrderDesignEmbellishment,
    deleteDraperyOrderDesignEmbellishment,
};
